import { TAO_KOE } from './../libs';

class Countdown {
	constructor( countdownEl ) {
		this.countdownEl = countdownEl;

		this.format = this.countdownEl.getAttribute( 'data-format' ) || '%dd | %hh | %ii | %ss';
		this.finish = this.countdownEl.getAttribute( 'data-timeout-text' ) || this.countdownEl.getAttribute( 'data-finish' ) || '';
		this.i18n = JSON.parse( this.countdownEl.dataset.i18n || false ) || {
			'dd': [ 'Tag', 'Tage' ],
			'hh': [ 'Stunde', 'Stunden' ],
			'ii': [ 'Minute', 'Minuten' ],
			'ss': [ 'Sekunde', 'Sekunden' ],
		};

		this.date = new Date( this.countdownEl.getAttribute( 'data-time' ) );
		this.interval = setInterval( () => this.update(), 500 );
	}

	getFormat( symbol, value ) {
		const i18n = this.i18n[ symbol ] ?? '';
		if ( Array.isArray( i18n ) ) {
			return value === 1 ? ( i18n[ 0 ] ?? '%d' ) : ( i18n[ 1 ] ?? '%d' );
		}

		return i18n;
	}

	update() {
		// Set the date we're counting down to
		const countDownTime = this.date.getTime();

		// Get todays date and time
		const now = new Date().getTime();

		// Find the distance between now an the count down date
		const distance = countDownTime - now;

		// Time calculations for days, hours, minutes and seconds
		const delta = {
			'd': Math.floor( distance / ( 1000 * 60 * 60 * 24 ) ),
			'h': Math.floor( ( distance % ( 1000 * 60 * 60 * 24 ) ) / ( 1000 * 60 * 60 ) ),
			'i': Math.floor( ( distance % ( 1000 * 60 * 60 ) ) / ( 1000 * 60 ) ),
			's': Math.floor( ( distance % ( 1000 * 60 ) ) / 1000 ),
		};

		delta.dd = this.getFormat( 'dd', delta.d ).replace( '%d', delta.d.toString() );
		delta.hh = this.getFormat( 'hh', delta.h ).replace( '%d', delta.h.toString() );
		delta.ii = this.getFormat( 'ii', delta.i ).replace( '%d', delta.i.toString() );
		delta.ss = this.getFormat( 'ss', delta.s ).replace( '%d', delta.s.toString() );

		const result = this.format.replaceAll( /%(([dhis])\2{0,1})/g, ( match, symbol ) => {
			return delta[ symbol ];
		} );

		// Display the result in the element with id <?php echo json_encode( $id ); ?>;

		if ( result !== this.countdownEl.innerHTML ) {
			this.countdownEl.innerHTML = result;
		}

		// If the count down is finished, write some text
		if ( distance <= 0 ) {
			this.onFinish();
		}
	}

	onFinish = function() {
		clearInterval( this.interval );
		if ( this.finish ) {
			this.countdownEl.innerHTML = this.finish;
		} else {
			const hideElement = this.countdownEl.dispatchEvent( new CustomEvent( 'hidden.koe', { bubbles: true } ) );
			if ( hideElement ) {
				this.countdownEl.style.display = 'none';
			}
		}
	};

	static init( scopeEl = document ) {
		const countdownEls = Array.from( scopeEl.getElementsByClassName( 'tao-countdown' ) );
		countdownEls.forEach( ( countdownEl ) => {
			countdownEl.KOE_COUNTDOWN ??= new Countdown( countdownEl );
		} );
	}
}

// Initialise immediately.
Countdown.init();
TAO_KOE.ready( 'countdown.js', () => Countdown.init() );

// Expose.
TAO_KOE.Countdown = Countdown;
export default Countdown;
